import { IAccountOrderDtoProofOfExpensesTypeEnum } from '@/dtos';
import { AccountOrder, Enrollment, PolicyEligibleService } from '@/modules/UseMyMoney/queries';

export type CombinedAccountData = {
  accountOrder?: AccountOrder;
  enrollment?: Enrollment;
  policyEligibleService?: PolicyEligibleService;
};

export const ProofOfExpenseTitle = {
  [IAccountOrderDtoProofOfExpensesTypeEnum.RECEIPT_REQUIRED]: 'Proof of expense required',
  [IAccountOrderDtoProofOfExpensesTypeEnum.NO_RECEIPT_REQUIRED]: 'Proof of expense not required, but helpful',
} as const;
